import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MetrikaService } from './metrika.service';

/**
 * Angular меняет роуты через History API, поэтому Метрика видит только первый
 * заход. Провайдер досылает хиты на каждый переход — без этого в отчётах
 * Директа вся сессия схлопывается в одну страницу.
 */
export function provideMetrikaSpaTracking(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const router = inject(Router);
    const metrika = inject(MetrikaService);

    router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        metrika.hit(window.location.origin + event.urlAfterRedirects);
      });
  });
}
